import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAccountingInterestBalance } from 'src/store/selectors/contractSelectors';
import AccountingInterestBalanceTable from './AccountingInterestBalanceTable';

const AccountingInterestBalance = ({ className, ...rest }) => {
  const balanceList = useSelector(selectAccountingInterestBalance);

  return (
    <Box display="flex" flexDirection="column" className={className}>
      <AccountingInterestBalanceTable balanceList={balanceList} {...rest} />
    </Box>
  );
};

AccountingInterestBalance.propTypes = {
  className: PropTypes.string
};

export default AccountingInterestBalance;
